import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { GroupActivity } from "@/@types/esus/GroupActivity";

type IndicatorEmultiM2GroupActivitiesHistoryItemProps = {
	groupActivity: GroupActivity;
};

export function IndicatorEmultiM2GroupActivitiesHistoryItem({
	groupActivity,
}: Readonly<IndicatorEmultiM2GroupActivitiesHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{groupActivity.healthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{groupActivity.healthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{groupActivity.professional?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{groupActivity.cbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
